module.exports = require("@swa-ui/placements");